<template>
  <div :id="id" class="echarts" />
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler: function() {
        this.dram()
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.dram()
  },
  methods: {
    dram() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '5%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(137, 157, 191, 1)',
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(137, 157, 191, 1)'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          },
          splitLine: {
            show: false
          },
          data: this.data.yData
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0,
                [{
                  offset: 0,
                  color: 'rgba(4, 104, 189, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(78, 228, 255, 1)'
                }]
              )
            },
            data: this.data.sData
          }
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .echarts{
    width: 100%;
    height: 100%;
  }
</style>
